import { createAction, props } from '@ngrx/store';
import { MgError } from '../../models/error.model';
import { States } from '../countries';
import { StatesRequest } from './states.model';

export enum StatesActions {
  getStates = '[States] getStatess',
  getStatesSuccess = '[States] getStatesSuccess',
  getStatesFailed = '[States] getStatesFailed',
  clearStates = '[States] clearStates',
}

export const GetStates = createAction(
  StatesActions.getStates,
  props<{ getStatesRequest: StatesRequest; endpoint: string }>()
);

export const GetStatesSuccess = createAction(
  StatesActions.getStatesSuccess,
  props<{ statesResponse: any }>()
);

export const GetStatesFailed = createAction(
  StatesActions.getStatesFailed,
  props<{ payload: { error: MgError; states: States[] } }>()
);

export const ClearStates = createAction(StatesActions.clearStates);
